<template>
  <div>
    <div v-loading="loading">
      <div v-if="detailData">
        <el-card shadow="hover">
          <warehouse-goods-info
            :imageSize="80"
            :goodsInfo="detailData"
            :showConsume="true"
          >
            <template slot="info-append">
              <div style="margin-top: 10px">
                <!-- <el-button @click="statusClick" type="primary">
                  {{
                    detailData.optSaleStatus == 1
                      ? "标记为已下架"
                      : "标记为售卖中"
                  }}
                </el-button> -->
              </div>
            </template>
          </warehouse-goods-info>
        </el-card>
        <div>
          <x-tab :tabs="tabs" :query="detailData" :params="detailData" />
        </div>
      </div>
      <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="getDetail" size="small"> 重新加载 </el-button>
      </el-empty>
    </div>
  </div>
</template>

<script>
import goodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";
import WarehouseGoodsInfo from "../../../../components/business/warehouseGoodsInfo.vue";
import tabStock from "./_detail_tab_stock.vue";
import tabReceipt from "./_detail_tab_receipt.vue";
import tabZsm from "./_detail_tab_zsm.vue";

export default {
  components: {
    goodsSkuInfo,
    WarehouseGoodsInfo,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    tabs() {
      if (!this.detailData) {
        return;
      }
      return [
        {
          name: "goods-stock",
          label: "库存信息",
          component: tabStock,
          interval: true,
        },
        {
          name: "goods-receipt",
          label: "库存日志",
          component: tabReceipt,
          interval: true,
        },
        {
          name: "goods-zsm",
          label: "追溯码库存",
          component: tabZsm,
          interval: true,
        },
      ];
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      detailData: null,
    };
  },
  methods: {
    statusClick() {
      const label = this.detailData.optSaleStatus == 1 ? "标记为已下架" : "标记为售卖中";
      this.$confirm(`确定${label}?`, "提示", {
        type: "warning",
      }).then(() => {
        this.requestApi(
          "biz.warehouse.goods.info.update",
          {
            guid: this.detailData.guid,
            optSaleStatus: this.detailData.optSaleStatus == 1 ? 0 : 1,
          },
          {
            showError: true,
          }
        ).then(() => {
          this.success("保存成功");
          this.$drawer.refreshDrawer();
          this.getDetail();
        });
      });
    },
    getDetail() {
      this.errorMsg = null;
      this.detailData = null;
      this.loading = true;
      return this.requestApi("biz.warehouse.goods.info.detail", {
        guid: this.pageParams.guid,
        storeGuid: this.pageParams.storeGuid,
      })
        .then((resp) => {
          this.loading = false;
          this.detailData = resp.data;
        })
        .catch((err) => {
          this.loading = false;
          this.errorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        });
    },
  },
  mounted() {
    this.getDetail();
  },
};
</script>
